import React from "react";
import LoadingInput from "../../_components/LoadingInput";
import Button from "../../_components/Button";
import Text from "../../_components/Text";
import {
  getSalesPerson,
  createSalePerson,
  updateSalesPerson,
} from "../../api/salespersons";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

export default (props) => {
  const [data, setData] = React.useState({ cpf: "", phone_number: "" });
  const [loading, setLoading] = React.useState(false);
  const { id } = useParams();

  const onChange = (e) =>
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });

  const onSave = (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!document.querySelector("form").checkValidity()) {
      return;
    }
    setLoading(true);
    const payload = {
      ...data,
      cpf: data.cpf.replace(/\D+/g, ""),
      phone_number: data.phone_number.replace(/\D+/g, ""),
    };
    if (!data.password) {
      delete payload.password;
    }
    const request = id
      ? updateSalesPerson(id, payload)
      : createSalePerson(payload);
    request
      .then((resp) => {
        setTimeout(() => {
          setLoading(true);
        }, 150);
        toast.success("Vendedor Salvo com sucesso!", {
          toastId: "create-salesperson-success",
          position: "top-center",
        });
        setTimeout(() => {
          window.location.href = "/salespersons";
        }, 2000);
      })
      .catch((error) => {
        if (error.email_error) {
          toast.error("Email já está cadastrado!", {
            toastId: "create-salesperson-error-email-already",
            position: "top-center",
          });
        } else if (error.cpf_error) {
          toast.error("CPF já está cadastrado!", {
            toastId: "create-salesperson-error-cpf-already",
            position: "top-center",
          });
        } else {
          toast.error("Error. Verifique os dados e tente novamente", {
            toastId: "create-salesperson-error",
            position: "top-center",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      getSalesPerson(id)
        .then((resp) => {
          setData({
            name: resp.name,
            cpf: resp.cpf,
            phone_number: resp.phone_number,
            email: resp.email,
          });
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  }, [id]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Text>Cadastrar Vendedor</Text>
        </div>
      </div>
      <form onSubmit={onSave} action="">
        <div className="row">
          <div className="col-md-4 col-xl-4 col-xs-12">
            <LoadingInput
              name="name"
              value={data.name}
              required
              disabled={loading}
              onChange={onChange}
              placeholder="Nome:"
              label="Nome"
            />
          </div>
          <div className="col-md-4 col-xl-4 col-xs-12">
            <LoadingInput
              name="cpf"
              required
              disabled={loading}
              onChange={onChange}
              type="cpf"
              value={data.cpf}
              placeholder="CPF:"
              label="CPF"
            />
          </div>
          <div className="col-md-4 col-xl-4 col-xs-12">
            <LoadingInput
              name="phone_number"
              onChange={onChange}
              required
              disabled={loading}
              type="phone_number"
              value={data.phone_number}
              placeholder="Telefone:"
              label="Telefone"
            />
          </div>
          <div className="col-md-4 col-xl-4 col-xs-12">
            <LoadingInput
              onChange={onChange}
              name="email"
              required
              value={data.email}
              disabled={loading}
              type="email"
              placeholder="E-mail:"
              label="Email"
            />
          </div>
          <div className="col-md-4 col-xl-4 col-xs-12">
            <LoadingInput
              type="password"
              name="password"
              onChange={onChange}
              required={!id}
              min={3}
              disabled={loading}
              placeholder="Senha de acesso:"
              label="Senha de acesso"
            />
          </div>
          <div className="col-12">
            <Button disabled={loading} type="submit">
              Salvar
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/SalesPersons/index.jsx